import React, { useState } from 'react';
import { Terminal as TerminalIcon } from 'lucide-react';

const Terminal: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="fixed bottom-4 right-4">
      <div className="relative">
        <button
          onClick={() => setIsVisible(!isVisible)}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          className="bg-primary text-primary-foreground p-2 rounded-full hover:bg-primary/90 transition-colors"
          aria-label="Toggle Terminal"
        >
          <TerminalIcon size={20} />
        </button>
        
        {showTooltip && (
          <div className="absolute bottom-full right-0 mb-2 w-48 bg-popover/90 backdrop-blur-sm text-popover-foreground text-sm rounded-lg p-2 border border-border shadow-lg">
            Terminal functionality coming soon!
          </div>
        )}
      </div>
    </div>
  );
};

export default Terminal;